import React, { useState, useEffect, useRef } from "react";
import Grid from "@mui/material/Grid2";

import { 
  Campaign, 
} from "@dndModels";

import ToastBox from "@components/display/ToastBox";
import CommonUtilities from "@utilities/common_utilities";
import CampaignPlayerInput from "./CampaignPlayerInput";
import ShareButton from "@components/input/buttons/icon_buttons/ShareButton";
import FlexBox from "@components/layout/FlexBox";
import RefreshButton from "@components/input/buttons/icon_buttons/RefreshButton";
import DandDAPI from "@utilities/smart_api";

const common_util = CommonUtilities.getInstance();
const api = DandDAPI.getInstance();

interface Props {
  campaign: Campaign;
}

export default function CampaignPlayersInput({ campaign }: Props) {
  const [reloading, setReloading] = useState(false);
  const [toast_time, setToastTime] = useState(0);
  const [processing, setProcessing] = useState(false);
  const mounted = useRef(false);

  useEffect(() => { 
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);
    
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  return (
    <FlexBox direction="column">
      <FlexBox direction="row">
        <FlexBox xs_expand={0} className="padded">
          <ShareButton
            label="Share Invite Link"
            onClick={() => {
              navigator.clipboard.writeText(`${window.location.origin}/campaign/join/${campaign._id}/${campaign.reusable_invite}`);
              setToastTime(common_util.get_time_number());
            }}
          />
          <ToastBox
            openTime={ toast_time }
          >
            Link copied to Clipboard
          </ToastBox>
        </FlexBox>
        <FlexBox xs_expand={0} className="padded">
          <RefreshButton
            disabled={processing}
            onClick={ async () => {
              setProcessing(true);
              campaign.c_players = undefined;
              campaign.c_chars = [];
              await api.loadCPlayers({ campaign, include_players: true });
              await api.loadCChars({ campaign, include_chars: true, include_players: true });
              setProcessing(false);
            }}
          />
        </FlexBox>
      </FlexBox>
      <Grid container spacing={0} direction="row">
        { campaign.players.map(player => {
          return (
            <Grid size={{ xs:12, sm: 6, md: 4, lg: 3 }} key={player._id}>
              <CampaignPlayerInput
                campaign={campaign}
                player={player}
                onUpdated={() => { setReloading(true); }}
              />
            </Grid>
          );
        })}
      </Grid>
    </FlexBox>
  );
}
